import { useQuery } from '@apollo/client';
import { affinityToStem } from '@ourbranch/policy-utils';
import useSession from 'core/hooks/use-session';
import { isSweepAccountsEnabled } from 'core/helpers/sweep-account';
import { GET_SWEEP_ACCOUNT } from 'core/components/sweep-account/sweep-account.queries';

export default function useSweepAccount(offer) {
  const { isInternalAgent, user } = useSession();
  const userStem = user?.affinityCode ? affinityToStem(user.affinityCode).toUpperCase() : null;
  const offerAffinity = offer?.quote?.global?.affinity;
  const offerStem = offerAffinity ? affinityToStem(offerAffinity).toUpperCase() : null;
  const eligible = isSweepAccountsEnabled() && !isInternalAgent && !!userStem && !!offerStem && userStem === offerStem;
  const { data, loading, error } = useQuery(GET_SWEEP_ACCOUNT, { skip: !eligible, fetchPolicy: 'no-cache' });
  return { eligible, loading, sweepAccount: eligible && !loading && !error ? data?.getSweepAccount : null };
}
